import gql from 'graphql-tag'

export const CREATE_EMAIL = gql`
  mutation CreateEmail($eventId: ID!, $email: EmailCreateInput!) {
    createEmail(eventId: $eventId, email: $email) {
      id
      subject
      content
    }
  }
`

export const CREATE_MEMBERSHIP_EMAIL = gql`
  mutation CreateMembershipEmail($organizationSlug: String!, $email: EmailCreateInput!) {
    createMembershipEmail(organizationSlug: $organizationSlug, email: $email) {
      id
      subject
      content
    }
  }
`

export const UPDATE_EMAIL = gql`
  mutation UpdateEmail($emailId: ID!, $email: EmailUpdateInput!) {
    updateEmail(emailId: $emailId, email: $email) {
      id
      eventId
      subject
      type
      content
      status
      sent
      createdAt
      updatedAt
      emailRecipient {
        id
        recipientType
        identifiers
      }
    }
  }
`

export const GET_EMAIL = gql`
  query GetEmail($emailId: ID!) {
    getEmail(emailId: $emailId) {
      id
      eventId
      subject
      type
      content
      status
      meta
      sent
      createdAt
      updatedAt
      replyTo
      emailRecipient {
        id
        recipientType
        identifiers
        notSentIdentifiers
      }
    }
  }
`

export const GET_EMAILS = gql`
  query GetEmails($eventId: ID!, $curatedInvitee: Boolean) {
    getEmails(eventId: $eventId, curatedInvitee: $curatedInvitee) {
      id
      eventId
      subject
      type
      content
      status
      sent
      createdAt
      updatedAt
      replyTo
      emailRecipient {
        id
        recipientType
        identifiers
      }
    }
  }
`

export const GET_EMAILS_BY_ORGANIZATION = gql`
  query GetEmailsByOrganizationSlug($organizationSlug: String!, $curatedInvitee: Boolean, $membershipEmail: Boolean) {
    getEmailsByOrganizationSlug(organizationSlug: $organizationSlug, curatedInvitee: $curatedInvitee, membershipEmail: $membershipEmail) {
      id
      eventId
      subject
      type
      content
      status
      sent
      createdAt
      updatedAt
      replyTo
      emailRecipient {
        id
        recipientType
        identifiers
      }
    }
  }
`

export const DELETE_EMAIL = gql`
  mutation DeleteEmail($emailId: ID!) {
    deleteEmail(emailId: $emailId)
  }
`

export const SEND_EMAIL = gql`
  mutation SendEmail($emailId: ID, $testEmailData: TestEmailDataInput) {
    sendEmail(emailId: $emailId, testEmailData: $testEmailData)
  }
`

export const SEND_MEMBERSHIP_EMAIL = gql`
  mutation SendMembershipEmail($emailId: ID) {
    sendMembershipEmail(emailId: $emailId)
  }
`

export const CHECK_AUTOMATED_EMAILS = gql`
  mutation CreateAutomatedEmails($eventId: ID!) {
    checkAutomatedEmails(eventId: $eventId)
  }
`

export const CREATE_ORGANIZATION_EMAIL = gql`
  mutation CrateOrganizationEmail($organizationSlug: String!, $email: EmailCreateInput!) {
    createOrganizationEmail(organizationSlug: $organizationSlug, email: $email) {
      id
      subject
      content
    }
  }
`

export const SEND_ORGANIZATION_EMAIL = gql`
  mutation SendOrganizationEmail(
    $organizationSlug: String!
    $emailId: ID!
    $testEmailData: TestEmailDataInput
  ) {
    sendOrganizationEmail(
      organizationSlug: $organizationSlug
      emailId: $emailId
      testEmailData: $testEmailData
    )
  }
`

export const GET_THEATER_SUBSCRIPTION_EMAILS = gql`
  query GetTheaterSubscriptionEmails($organizationSlug: String!) {
    getTheaterSubscriptionEmails(organizationSlug: $organizationSlug) {
      id
      subject
      type
      content
      status
      sent
      theaterDeliverySummary {
        status
        total
        sent
        failed
        pending
        unknown
      }
      createdAt
      updatedAt
      replyTo
      emailRecipient {
        id
        recipientType
        identifiers
      }
    }
  }
`

export const GET_ORGANIZATION_SUBSCRIPTION_EMAILS = gql`
  query GetOrganizationSubscriptionEmails($organizationSlug: String!) {
    getOrganizationSubscriptionEmails(organizationSlug: $organizationSlug) {
      id
      subject
      type
      content
      status
      sent
      createdAt
      updatedAt
      replyTo
      emailRecipient {
        id
        recipientType
        identifiers
      }
    }
  }
`
